import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appTimeSpan',
})
export class TimeSpanPipe implements PipeTransform {
  public transform(value: number | undefined | null): string {
    if (value == null || isNaN(value)) return '00:00:00';

    const totalSeconds = Math.floor(value);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      return `${hours}u ${minutes}m`;
    } else {
      return `${minutes}m ${seconds}s`;
    }
  }
}
